export enum AutoCompleteField {
    customerNo, 
    machineNo, 
    salesforce,
    name
  }